import usePathListener from "hooks/usePathListener";
import React from "react";

const withPathListener = (WrappedComponent) => (props) => {
  const { pathname } = usePathListener();

  return <WrappedComponent {...props} path={pathname} />;
};

export default withPathListener;
